"use client";

import * as React from "react";

// Define the shape of the context value
interface TryOnContextType {
  apiKey: string;
  token: string;
}

// Create a context with a default value or undefined
const TryOnContext = React.createContext<TryOnContextType | undefined>(
  undefined
);

// Props for the provider component
interface TryOnProviderProps {
  apiKey: string;
  token: string;
  children: React.ReactNode;
}

const TryOnProvider: React.FC<TryOnProviderProps> = ({
  apiKey,
  token,
  children,
}) => {
  return (
    <TryOnContext.Provider value={{ apiKey, token }}>
      {children}
    </TryOnContext.Provider>
  );
};

// Custom hook to use the TryOn context
export const useTryOn = (): TryOnContextType => {
  const context = React.useContext(TryOnContext);
  if (!context) {
    throw new Error("useTryOn must be used within a TryOnProvider");
  }
  return context;
};

export default TryOnProvider;
